import { cloneDeep } from "lodash"
import { ChannelModel } from "../../channel/models/ChannelModel"
import { SubscriberModel } from "../../subscriber/models/SubscriberModel"
import { ProductModel } from "./ProductModel"
import { ProductStoreChannelModel } from "./ProductStoreChannelModel"
import { ProductStoreChannelStatusModel } from "./ProductStoreChannelStatusModel"

export class ProductStoreChannelStatusFormModel {
    product: ProductModel = new ProductModel()
    subscriber: SubscriberModel = new SubscriberModel()
    storeChannelList: ProductStoreChannelModel[] = []
    variations: any[] = []

    constructor(p:Partial<ProductModel> = new ProductModel(), channelList: ChannelModel[] = [], s: SubscriberModel = new SubscriberModel()) {
        const product = (p instanceof ProductModel) ? p as ProductModel : new ProductModel(p)
        this.subscriber = (s instanceof SubscriberModel) ? s as SubscriberModel : new SubscriberModel(s)
        this.product = ProductModel.normalizeV1(product, this.subscriber)
        this.variations = this.product.children.filter((c) => c.hasAttributeTypeGrid()).map((v) => {
            return new ProductModel({
                ...v,
                // @ts-ignore
                storeChannelList: v.getUniqueStoreChannels().filter((productStoreChannel) => {
                    return productStoreChannel.channel!.isWooCommerce() ||
                        productStoreChannel.channel!.isTray() ||
                        productStoreChannel.channel!.isB2W() ||
                        productStoreChannel.channel!.isNuvemShop()
                }),
            })
        })
        this.storeChannelList = this.product.getUniqueStoreChannels().filter((productStoreChannel) => {
            return productStoreChannel.channel!.isWooCommerce() ||
                productStoreChannel.channel!.isTray() ||
                productStoreChannel.channel!.isB2W() ||
                productStoreChannel.channel!.isNuvemShop()
        })

        channelList.forEach((channel) => {
            if (!this.storeChannelList.find((sc) => sc.channel!.id === channel.id)) {
                this.storeChannelList.push(new ProductStoreChannelModel({
                    isActive: false,
                    channel: cloneDeep(channel),
                }))
            }

            this.variations.forEach((v) => {
                if (!v.storeChannelList.find((sc: ProductStoreChannelModel) => sc.channel!.id === channel.id)) {
                    v.storeChannelList.push(new ProductStoreChannelModel({
                        isActive: false,
                        channel: cloneDeep(channel),
                    }))
                }
            })
        })        
    }

    getProductStatus(productStoreChannel: ProductStoreChannelModel): ProductStoreChannelStatusModel[] {
        let idProduct = this.product?.id

        if (this.subscriber.isBackendBimer() && !this.product.hasChildren()) {
            idProduct = this.product.firstChildId
        }

        const statusList:ProductStoreChannelStatusModel[] = [
            {
                idProduct: idProduct as number,
                isActive: productStoreChannel.isActive,
                idChannel: productStoreChannel.idChannel,
            }
        ]

        return statusList
    }

    getVariationStatus(variation: ProductModel, variationStoreChannel: ProductStoreChannelModel, isActive: boolean): ProductStoreChannelStatusModel[] {
        const statusList:ProductStoreChannelStatusModel[] = [
            {
                idProduct: variation.id as number,
                isActive: variationStoreChannel.isActive,
                idChannel: variationStoreChannel.idChannel,
            }
        ]

        return statusList
    }

    getStatusList():ProductStoreChannelStatusModel[] {
        const statusList:ProductStoreChannelStatusModel[] = []

        this.storeChannelList.forEach((storeChannel) => {
            let idProduct = this.product?.id

            if (this.subscriber.isBackendBimer() && !this.product.hasChildren()) {
                idProduct = this.product.firstChildId
            }

            statusList.push({
                idProduct: idProduct as number,
                idChannel: storeChannel.channel?.id as string,
                isActive: storeChannel.isActive,
            })
        })

        this.variations.forEach((v) => {
            v.storeChannelList.forEach((vStoreChannel: ProductStoreChannelModel) => {
                statusList.push({
                    idProduct: v.id as number,
                    idChannel: vStoreChannel.channel?.id as string,
                    isActive: vStoreChannel.isActive,
                })
            })
        })

        return statusList
    }
}
